import { cn, Stack, Typography } from '@prenuvo/halo-foundation';

import { FCT } from '@/i18n';

interface DocumentErrorProps {
  className?: string;
}

export function DocumentError({ className }: DocumentErrorProps) {
  return (
    <Stack
      alignment="center"
      className={cn('h-[calc(100vh-128px)]', className)}
      justification="center"
    >
      <Typography>{FCT.PATIENT_DOCS.SIDE_PANEL.ERROR}</Typography>
    </Stack>
  );
}
